var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 2,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.417 1c0-.506.41-.917.916-.917h9.334a.917.917 0 110 1.834H1.333A.917.917 0 01.417 1z",
    fill: "#0D4774"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMiIgdmlld0JveD0iMCAwIDEyIDIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMC40MTY2MjYgMS4wMDAxNkMwLjQxNjYyNiAwLjQ5MzkwMiAwLjgyNzAzMiAwLjA4MzQ5NjEgMS4zMzMyOSAwLjA4MzQ5NjFIMTAuNjY2NkMxMS4xNzI5IDAuMDgzNDk2MSAxMS41ODMzIDAuNDkzOTAyIDExLjU4MzMgMS4wMDAxNkMxMS41ODMzIDEuNTA2NDIgMTEuMTcyOSAxLjkxNjgzIDEwLjY2NjYgMS45MTY4M0gxLjMzMzI5QzAuODI3MDMyIDEuOTE2ODMgMC40MTY2MjYgMS41MDY0MiAwLjQxNjYyNiAxLjAwMDE2WiIgZmlsbD0iIzBENDc3NCIvPgo8L3N2Zz4K";
export { SvgMinus as ReactComponent };